import React from "react";
import { Box, Button, Grid, Typography, List, ListItem, ListItemText } from "@mui/material";
import "./house-rules-first.css";

const HouseRulesFirst = ({ nextStep, prevStep }) => {
  return (
    <Box className='house-container-form'>
      <Box className='top-right-character'>
        <img src='./CYPImages/WormisDryStem.png' alt='Top Right Character' className='top-right-character-image' />
      </Box>

      <Box mt={8} mb={20}>
        <Box className='house-form-container'>
          {/* Title */}
          <Typography variant='h4' className='house-rules-title' sx={{ textAlign: "center", color: "#1976d2" }}>
            House Rule
          </Typography>

          {/* House Rules List */}
          <List sx={{ mt: 4 }}>
            <ListItem>
              <ListItemText
                primary='• Be kind and respectful to all'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Your room is your personal space. Staff can come in with your permission.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Bedtime is at 10:30pm Sunday – Thursday & 11:00pm on Friday, Saturday and holidays.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Your room is your sanctuary, please.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Keep your room clean and tidy.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Bedroom deep clean every Friday.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Bedroom deep clean every Friday before any pocket is received.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• No vaping or smoking in the house or around the perimeter.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Engage with Education, Activities and Keywork sessions.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• All meals are eaten at the dining room table.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
            <ListItem>
              <ListItemText
                primary='• Good parenting checks are done by adults every morning to make sure your room is safe.'
                primaryTypographyProps={{ variant: "body1", sx: { fontFamily: "Comic Sans MS", color: "#2E3B55" } }}
              />
            </ListItem>
          </List>

          {/* Submit Button */}
          <Box mt={3}>
            <Grid container justifyContent='space-between' alignItems='center' mt={2}>
              <Grid item>
                <Button type='button' variant='contained' color='primary' onClick={prevStep}>
                  Previous
                </Button>
              </Grid>
              <Grid item>
                <Button type='submit' variant='contained' color='primary' onClick={nextStep}>
                  Next
                </Button>
              </Grid>
            </Grid>
          </Box>
        </Box>
      </Box>

      <Box className='left-bottom-little'>
        <img src='./CYPImages/littleHome.png' alt='left character' className='left-bottom-little-image' />
      </Box>
      <Box className='bottom-house-rules'>
        <img src='./CYPImages/walkboy.png' alt='Bottom Character' className='bottom-house-rules-image' />
      </Box>
    </Box>
  );
};

export default HouseRulesFirst;
